// extracted by mini-css-extract-plugin
export default {"column":"ModalSyncData_column__RxM0F"};